module.exports = __webpack_public_path__ + "static/media/yes_no01.36159e6f.png";